import {flow, types} from "mobx-state-tree";
import {orderBy} from "lodash";

import {llattempt} from "../../../../common/utils";
import api from "../../../../common/api";
import {llNotifier} from "../../../../components";


const AffiliatesItem = types
    .model('PaymentItem', {
        userName: types.string,
        registrationDate: types.string,
        sportsProfit: types.number,
        casinoProfit: types.number,
        otherProfit: types.number,
        bonus: types.number,
        totalProfit: types.number,
    })

const Affiliates = types
    .model('Payments', {
        items: types.array(AffiliatesItem),
    })
    .actions((self) => ({
        _set(data) {
            self.items = [];
            if (data?.length) {
                orderBy(data, ['RegistrationDate'], ['desc']).map((item) =>
                    self.items.push(
                        AffiliatesItem.create({
                            userName: item.UserName,
                            registrationDate: item.RegistrationDate,
                            sportsProfit: item.SportsProfit,
                            casinoProfit: item.CasinoProfit,
                            otherProfit: item.OtherProfit,
                            bonus: item.Bonus,
                            totalProfit: item.TotalProfit,
                        })
                    )
                );
            }
            self.fetchTime = Date.now();
            self.isTableLoading = false;
        },
        getAffiliates: flow(function* fetch() {
            return yield llattempt(
                () => {
                    self.isTableLoading = true;
                    api.user.getAffiliates({
                        from: parseInt(new Date(self.startDate.setHours(0, 0, 0, 1)).getTime() / 1000),
                        to: parseInt(new Date(self.endDate.setHours(23, 59, 59, 999)).getTime() / 1000),
                    }).then((response) => {
                        if (!response.success || response.data?.error) {
                            self.resetFetchTimeAndLoading();
                            // Thing below needed to avoid double error notifier on logout
                            if (response.data?.error === 'AUTH_REQUIRED') {
                                return true;
                            } else {
                                llNotifier({
                                    message: response.data?.error ?? 'GENERAL_ERROR',
                                    type: 'error',
                                });
                            }
                            return true;
                        }
                        self._set(response.data);
                    });
                },
                {
                    msg: 'GENERAL_ERROR',
                    at: 'user.login',
                    withParams: {
                        from: parseInt(new Date(self.startDate.setHours(0, 0, 0, 1)).getTime() / 1000),
                        to: parseInt(new Date(self.endDate.setHours(23, 59, 59, 999)).getTime() / 1000),
                    },
                    onError: () => {
                        self.resetFetchTimeAndLoading();
                        llNotifier({
                            message: 'GENERAL_ERROR',
                            type: 'error',
                        });
                    },
                }
            );
        }),
    }))

export default Affiliates;